import { logger } from '../services/loggerService';

export default {
  install: (app) => {
    // Make logger available in template and options API via this.$logger
    app.config.globalProperties.$logger = logger;
    
    // Make logger available in Composition API via inject('logger')
    app.provide('logger', logger);
  }
}; 